<div [ngClass]="{'capability-card': true, '--horizontal': layout === 'horizontal', '--vertical': layout === 'vertical'}">
  <span class="capability-card-icon">
    <ng-container *ngIf="layout === 'horizontal' && icon">
      <lucide-icon [name]="icon"></lucide-icon>
    </ng-container>
    <ng-container *ngIf="layout === 'vertical' && icon">
      <icon [icon]="icon" class="vertical-icon"></icon>
    </ng-container>
  </span>
  <div class="capability-card-content">
    <h3 class="capability-card-title">{{ title }}</h3>
    <ul class="capability-card-list">
      @for (item of items; track item) {
      <li>{{ item }}</li>
      }
    </ul>
  </div>
</div>
